var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-0 h-100"},[_c('h3',[_vm._v("Rules List")]),_c('order-rules-grid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }